import "./PeripheralArterialDisease.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { Link } from "@/components/common/Link";
export default function PeripheralArterialDiseasePage() {
  return <div>
      <Header />
      <section className="bg-[var(--color-dark-navy)] pt-32 pb-16 px-6 lg:px-12 font-default">
        <p className="text-sm uppercase tracking-widest text-red-500 mb-4">Services</p>
        <h1 className="font-bold text-3xl md:text-4xl uppercase tracking-tight text-white mb-6">Transformative Treatment for Peripheral Arterial Disease</h1>
        <p className="text-lg text-soft-gray max-w-3xl">Peripheral Arterial Disease (PAD) is a common circulatory problem that is caused by narrowed arteries. The reduction of blood flow leads to limb pain, numbness, and sores. Dr. Carrillo-Jimenez and the team at Florida Premier Cardiology can provide you with a comprehensive PAD treatment plan focused on improving symptoms and supporting better health.</p>
      </section>
      <section className="bg-background text-foreground py-16 px-6 lg:px-12 font-default">
        <div className="max-w-3xl mx-auto space-y-10">
          <div>
            <h2 className="font-bold text-2xl md:text-3xl uppercase tracking-tight mb-4 text-red-500">Utilizing State-Of-The-Art Technology</h2>
            <ul className="list-disc list-inside text-base text-soft-gray leading-relaxed space-y-2">
              <li>Non-invasive vascular testing</li>
              <li>Doppler and ultrasound imaging</li>
              <li>Angiography</li>
              <li>Angioplasty and stenting</li>
              <li>Atherectomy</li>
            </ul>
          </div>
          <div>
            <h2 className="font-bold text-2xl md:text-3xl uppercase tracking-tight mb-4 text-red-500">Preventing Serious Future Health Problems</h2>
            <p className="text-base text-soft-gray leading-relaxed">Peripheral arterial disease can lead to major health setbacks, including stroke, heart attack, and gangrene. Minimize your risk of serious future complications by choosing Florida Premier Cardiology for the necessary evaluation and care.</p>
          </div>
        </div>
      </section>
      <section className="bg-[var(--color-dark-navy)] py-16 px-6 lg:px-12 font-default text-center">
        <p className="text-white text-lg max-w-2xl mx-auto mb-8">Ready to get evaluated for peripheral arterial disease? Contact our team today.</p>
        <Link to="/contact-us/" className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-10 py-5 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200">Contact Us</Link>
      </section>
      <Footer />
    </div>;
}
